import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import config from "../../../config";

// components
import Widget from "../../../components/Widget/Widget";
import FingerPrintTable from "./FingerPrintTable";

// styles
import useStyles from "../styles";

export default function FingerPrintSection() {
  const classes = useStyles();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [allData, setAllData] = useState([]);

  const fetchFingerPrints = async () => {
    fetch(baseUrl + "getFingerPrintsUnused",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        const newData = data;

        if (newData != null) {
          setAllData(newData);
        }
      })
      .catch(error => { });
  }

  useEffect(() => {
    fetchFingerPrints();
  }, []);

  const onDelete = (property) => async (event) => {
    event.preventDefault();

    const response = await fetch(baseUrl + "getFingerPrintsUnusedDelete/" + property, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json', 'Content-Type': 'application/json',
        'Authorization': localStorage.getItem("token")
      },
    });

    const json = await response.json();
    if (json.status == "Ok") {
      fetchFingerPrints();
    } else {
      if (json.message == "Access is denied") { }
    }
  };

  const onDeleteAll = async event => {
    event.preventDefault();

    const response = await fetch(baseUrl + "getFingerPrintsUnusedDeleteAll/", {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json', 'Content-Type': 'application/json',
        'Authorization': localStorage.getItem("token")
      },
    });

    const json = await response.json();
    if (json.status == "Ok") {
      fetchFingerPrints();
    } else {
      if (json.message == "Access is denied") { }
    }
  };

  return (
    <>
      <div>
        <div className={classes.divTitle}>
          <label className={classes.titleStyle}>Huellas digitales</label>
        </div>

        <Grid item xs={12}>
          <Widget
            noBodyPadding
            bodyClass={classes.tableWidget}
          >
            <FingerPrintTable
              data={allData}
              onDelete={onDelete}
              onDeleteAll={onDeleteAll}
            />
          </Widget>
        </Grid>
      </div>
    </>
  );
}
